export function requestIdleCallback(callback) {
  if (window.requestIdleCallback) {
    window.requestIdleCallback(callback)
  } else {
    window.setTimeout(callback)
  }
}
